import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const createSegment = (data, tenantEmail) =>
  axios.post(`${API}/api/segments`, data, {
    headers: { "x-email": tenantEmail },
  });

export const getSegments = (tenantEmail) =>
  axios.get(`${API}/api/segments`, {
    headers: { "x-email": tenantEmail },
  });

export const previewSegmentUsers = (id, tenantEmail) =>
  axios.get(`${API}/api/segments/${id}/preview`, {
    headers: { "x-email": tenantEmail },
  });

// NEW: Function to update an existing segment
export const updateSegment = (id, data, tenantEmail) =>
  axios.put(`${API}/api/segments/${id}`, data, {
    headers: { "x-email": tenantEmail },
  });

// NEW: Function to delete a segment
export const deleteSegment = (id, tenantEmail) =>
  axios.delete(`${API}/api/segments/${id}`, {
    headers: { "x-email": tenantEmail },
  });